import React, { Fragment, useState } from 'react';
import ConsuRescaMensaje from '../components/consuRescaMensaje/consuRescaMensaje';
import ConsideracionesCR from '../components/consideracionesCR/consideracionesCR';
import ConsuRescaLayout from '../components/consuRescaLayout/consuRescaLayout';
import ConsuRescaRegExito from '../components/consuRescaRegExito/consuRescaRegExito';
import ConsuReinversion from '../components/consuReinversion/consuReinversion';
import {CONTENT_PAG} from '../constants/content_pag';

const ConsultaRescate = () => {

  const [ pagConsultaRescate, mostrarPagConsultaRescate] = useState(CONTENT_PAG.PAG_MENS);

  const mostrarPaginaRecate = () => {
    switch(pagConsultaRescate) {
      case CONTENT_PAG.PAG_MENS  : return <ConsuRescaMensaje mostrarPagConsultaRescate={mostrarPagConsultaRescate}/>;
      case CONTENT_PAG.PAG_CONS  : return <ConsideracionesCR mostrarPagConsultaRescate={mostrarPagConsultaRescate}/>;
      case CONTENT_PAG.PAG_REGI  : return <ConsuRescaRegExito />
      case CONTENT_PAG.PAG_LAYO  : return <ConsuRescaLayout mostrarPagConsultaRescate={mostrarPagConsultaRescate}/>;
      case CONTENT_PAG.PAG_REIN  : return <ConsuReinversion mostrarPagConsultaRescate={mostrarPagConsultaRescate}/>;
      default : return <h1>Pagina en construcción</h1>
    }
  }

  return ( 
    <Fragment>
      { mostrarPaginaRecate() }
    </Fragment>
  );
}
 
export default ConsultaRescate;